<template>
  <div>
    <b-card
      no-body
      class="my-1 pb-2"
      :class="{ 'card-transparent-background': type == 'register' }"
    >
      <b-card-header
        class=""
        :class="{
          'card-header-profile-border': type == 'profile' || type == 'edit',
          'card-header-form-doorder': type == 'register',
        }"
        ><h4>Payment Details</h4></b-card-header
      >
      <b-card-body class="py-0">
        <div class="container">
          <b-row>
            <b-col md="12" class="mb-2">
              <b-row class="mb-2">
                <b-col>
                  <b-form-group
                    class="form-group-checkbox-group form-group-check-doorder"
                  >
                    <b-form-checkbox
                      id="add_payment"
                      v-model="add_payment"
                      name="add_payment"
                      value="true"
                      unchecked-value="false"
                    >
                      Add payment details??
                    </b-form-checkbox>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row
                class="mt-1 checkboxInputContainerDoorder"
                v-if="add_payment == 'true'"
              >
                <b-col>
                  <b-form-group
                    class="form-group-checkbox-group form-group-check-doorder"
                    label=""
                    v-slot="{ ariaDescribedby }"
                  >
                    <p
                      class="error_validation_message_p"
                      v-if="invalid_contact_through"
                    >
                      Please select payment
                    </p>

                    <b-form-radio-group
                      id="payment_type"
                      v-model="payment_type"
                      :aria-describedby="ariaDescribedby"
                      name="payment_type"
                    >
                      <b-form-radio value="card">Card details</b-form-radio>
                      <b-form-radio value="iban">Bank account</b-form-radio>
                    </b-form-radio-group>
                  </b-form-group>
                </b-col>
              </b-row>
              <StripeComponentPayment
                ref="stripe_component"
                client_name="Doorder"
                :require_card="require_card"
                :stripe_token.sync="stripe_token"
                element_class_base="form-control form-control-doorder"
                form_group_class="form-group-doorder"
              />
              <IBANStripeComponent
                ref="iban_stripe_component"
                client_name="Doorder"
                :require_card="require_iban"
                :stripe_token.sync="stripe_token"
                element_class_base="form-control form-control-doorder"
                form_group_class="form-group-doorder"
              />
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <b-form-group
                class="form-group-doorder"
                label="Retailer's charging day "
                label-for="charging_day"
                label-class="form-label-doorder"
              >
                <p
                  class="error_validation_message_p"
                  v-if="invalid_charging_day"
                >
                  Please select day
                </p>
                <v-select
                  :options="charging_day_options"
                  v-model="charging_day"
                  name="charging_day"
                  :reduce="(item) => item.code"
                  placeholder="Select day"
                  required
                ></v-select>
              </b-form-group>
            </b-col>
          </b-row>
        </div>
      </b-card-body>
    </b-card>
  </div>
</template>
 
<script>
import $ from "jquery";
import moment from "moment";
import StripeComponentPayment from "@/components/Payment/StripeComponentPayment";
import IBANStripeComponent from "@/components/Payment/IBANStripeComponent";

export default {
  name: "PaymentDetailsIBAN",

  components: { StripeComponentPayment, IBANStripeComponent },
  props: [
    "type",
    "require_card",
    "stripe_token",
    "add_payment",
    "payment_type",
  ],
  data() {
    return {
      invalid_contact_through: false,
      require_iban: false,
      charging_day: null,
      charging_day_options: [],
      invalid_charging_day: false
    };
  },
  mounted() {
    this.charging_day_options = [
      { label: "No override", code: "No override" },
      { label: "Do not auto charge", code: "0" },
    ];
    for(let i=1; i<=31; i++){
       this.charging_day_options.push({label: i, code: i})
    }
  },
  watch: {
    payment_type(newVal, oldVal) {
      console.log("payment type", oldVal, newVal);
      if (newVal == "card") {
        this.require_card = true;
        this.require_iban = false;
      } else {
        this.require_card = false;
        this.require_iban = true;
      }
    },
  },
  updated() {
    console.log(this.require_card);
    this.$emit("update:require_card", this.require_card);

    console.log(this.stripe_token);
    this.$emit("update:stripe_token", this.stripe_token);
  },
  methods: {
    testtest() {
      console.log("click testtest");
    },
  },
};
</script>

<style >
</style>


// WEBPACK FOOTER //
// src/components/doorder/retailers/profile_details_components/PaymentDetailsIBAN.vue